<template>
  <div>
    <DocumentHeader header="แก้ไขใบส่งคืนสินค้า" link_back="stock/document/returnproductreceipt"/>
    <Government_receipt_edit/>
  </div>
</template>

<script>
import DocumentHeader from "@/components/admin/document_stock/header_document/DocumentHeader";
import Government_receipt_edit from "@/components/admin/document_stock/Government_receipt_edit";
export default {
  name: "GovernmentReceiptEdit",
  components: {
    Government_receipt_edit,
    DocumentHeader
  }
}
</script>

<style scoped>

</style>
